export enum AllotmentRequestPath {
  TODO = 'todo',
  IN_PROGRESS = 'in-progress',
  READY_FOR_BATCH = 'ready-for-batch',
  PENDING_DOE_APPROVAL = 'pending-doe-approval',
  SUBMITTED_AR = 'submitted-ar',
}
